import PageTable from './PageTable';

export default PageTable;
